module.exports = __webpack_public_path__ + "static/media/Crossroads.7bcefb80.jpg";